//export const API_URL = 'https://testadminlegacywatches.pleximus.co.in';
export const API_URL = 'https://adminlegacywatches.pleximus.co.in';
// export const API_URL = 'http://127.0.0.1:8000';

export const SiteTitle = 'Legacy Watch Co.';
